
function vueReadonlyrating() {
    return Vue.component('readonlyrating', {
        props: ['rating'],
        template: '<div class="rating" v-html="markup" :title="rating"></div>',
        data: function () {
            return {
                markup: ''
            }
        },
        mounted: function () {
            this.markup = '';
            for (var i = 0; i < 5; i++) {
                var isHalf = this.rating > i && this.rating < i + 1;
                var isEmpty = this.rating < i + 1 && this.rating <= i;
                var emptyCss = isEmpty ? " grey" : "";
                if (isHalf) {
                    this.markup += '<i class="fa fa-star grey"></i>';
                    this.markup += '<i class="fa fa-star-half"></i>';
                }
                else {
                    this.markup += '<i class="fa fa-star' + emptyCss + '"></i>';
                }
            }

        }
    });
}
